export default "__VITE_ASSET__Ce8CFDI___"